import { Typography } from 'antd';
import Language from '@/constants/Language';

const { Text, Title } = Typography;

export function Pricing({
  title,
  language,
  price,
  description,
  Button,
  children,
}) {
  return (
    <div className="pricing-wrapper">
      <div className="header">
        <h2>
          {title} {Language.labels[language]}
        </h2>
        <div className="subheader">
          <Title className="price" level={2}>
            ${price}
          </Title>
          <Text className="description">{description}</Text>
        </div>
      </div>
      <hr className="separator"></hr>
      <div className="button-container">{Button}</div>
      {children}
    </div>
  );
}

export function DefaultPricingContainer({ children }) {
  return (
    <div className="default-pricing-container pricing-container">
      {children}
    </div>
  );
}

export function MostPopular({ children }) {
  return (
    <div className="most-popular-container pricing-container">
      <div className="text-container">
        <Text className="text small-text">Most Popular</Text>
      </div>
      {children}
    </div>
  );
}
